export const environment = {
    name: 'dev',
    apiEndpoint: 'https://br7zl3pqq9.execute-api.us-east-1.amazonaws.com/prod',
    putterClubId: 23
}